//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const stakeholderListSearchSlice = createSlice({
    name: 'stakeholderListSearchSlc',
    initialState: {value: {
            id: null,
            fileId: null,
            recordId: null,
            productId: null,
            productName: null,
            episodeName: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seriesExternalId: null,
            seriesName: null,
            seasonExternalId: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            seasonName: null,
            guild: null,
            fsoId: null,
            fsoTaxId: null,
            fsoFirstName: null,
            fsoLastName: null,
            fsoSuffix: null,
            contractedPartyId: null,
            contractedPartyTaxId: null,
            contractedPartyFirstName: null,
            contractedPartyLastName: null,
            contractedPartySuffix: null,
            contractedPartyCompanyName: null,
            payeeId: null,
            payeeTaxId: null,
            payeeFirstName: null,
            payeeLastName: null,
            payeeSuffix: null,
            payeeCompanyName: null,
            jobCode: null,
            contractLength: null,
            participations: null,
            residuals: null,
            royalties: null
        }},
    reducers:
        // {
        //     changeStakeholderListSearch: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
        changeStakeholderListSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeStakeholderListSearch } = stakeholderListSearchSlice.actions;

export default  stakeholderListSearchSlice.reducer ;

// import reducer from "../reducer";

